import Svg, { Path } from '@rd-core-svg/svg'
import type { LogoSvgProps } from '../svg.types'

export const DrogasilWhiteSymbol = (props: LogoSvgProps) => {
  return (
    <Svg {...props} viewBox="0 0 57 56" fill="none">
      <Path
        d="M32.0452 0.647099C30.9825 -0.481358 29.6591 -0.0178896 29.7193 1.37253L30.5213 15.4379C30.8622 21.8258 34.4915 25.5739 40.8679 25.8963L54.8639 26.7024C56.2475 26.7628 56.6485 25.4933 55.5858 24.3648L32.0452 0.647099Z"
        fill="white"
      />
      <Path
        d="M54.8434 29.3025L40.8474 30.1085C34.471 30.4511 30.8417 34.179 30.5008 40.5669L29.6988 54.6323C29.6386 56.0227 30.962 56.5064 32.0247 55.3578L55.5653 31.64C56.6481 30.4914 56.247 29.2219 54.8434 29.3025Z"
        fill="white"
      />
      <Path
        d="M25.6685 40.5667C25.3276 34.1587 21.6983 30.4307 15.3219 30.1083L1.32591 29.3023C-0.0576526 29.2418 -0.458685 30.5718 0.604048 31.6398L24.1446 55.3576C25.2073 56.486 26.5307 56.0225 26.4706 54.6321L25.6685 40.5667Z"
        fill="white"
      />
      <Path
        d="M24.1446 0.647759L0.604048 24.3655C-0.458685 25.4335 -0.0576526 26.7635 1.32591 26.703L15.3219 25.897C21.6983 25.5544 25.3276 21.8265 25.6685 15.4386L26.4706 1.37319C26.5307 -0.0373805 25.2073 -0.500849 24.1446 0.647759Z"
        fill="white"
      />
    </Svg>
  )
}
